/* eslint-disable */ 
jQuery('.Header-openBoxSearch').on('click', () => {
  jQuery('.BoxSearch').addClass('BoxSearch-isActive');
})

jQuery('.BoxSearch-close, .BoxSearch-overlay').on('click', () => {
  jQuery('.BoxSearch').removeClass('BoxSearch-isActive');
})